import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, FileText } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#070B14] border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <img
              src="/assets/yc-logo.jpeg"
              alt="YC SYSTEM - Security & AV Integrator"
              className="w-44 mb-4 border border-white/10"
              data-testid="footer-logo"
            />
            <p className="text-sm text-slate-400 leading-relaxed">
              Trading of ELV, CCTV &amp; Security Systems. System integration for commercial,
              industrial and residential facilities across Malaysia.
            </p>
          </div>

          <div>
            <h4 className="tech-label mb-4">Solutions</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/security-systems" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-security-link">Security Systems</Link></li>
              <li><Link to="/elv-systems" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-elv-link">ELV Systems</Link></li>
              <li><Link to="/pa-av-systems" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-pa-av-link">PA &amp; AV Systems</Link></li>
              <li><Link to="/quote" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-quote-link">Request a Quote</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="tech-label mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-about-link">About YC System</Link></li>
              <li><Link to="/why-choose-us" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-why-link">Why Choose Us</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-cyan-400 transition-colors" data-testid="footer-contact-link">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="tech-label mb-4">Headquarters</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex gap-2">
                <MapPin className="w-4 h-4 text-cyan-400 shrink-0 mt-0.5" />
                <span>Suite 33-01, 33rd Floor, Menara Keck Seng, 203 Jalan Bukit Bintang, 55100 Kuala Lumpur</span>
              </li>
              <li className="flex gap-2 items-center">
                <Phone className="w-4 h-4 text-cyan-400 shrink-0" />
                <a href="https://wa.me/601172283321" className="hover:text-cyan-400 transition-colors" data-testid="footer-whatsapp-link">011-7228 3321</a>
              </li>
              <li className="flex gap-2 items-center">
                <Mail className="w-4 h-4 text-cyan-400 shrink-0" />
                <a href="mailto:ycsystem.sales@gmail.com" className="hover:text-cyan-400 transition-colors" data-testid="footer-email-link">ycsystem.sales@gmail.com</a>
              </li>
              <li className="flex gap-2 items-center">
                <FileText className="w-4 h-4 text-cyan-400 shrink-0" />
                <span className="font-tech text-xs">Reg. No. 201903139239</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} YC SYSTEM. All rights reserved.</span>
          <span className="font-tech">ELV • CCTV • SECURITY SYSTEMS • KUALA LUMPUR</span>
        </div>
      </div>
    </footer>
  );
}
